import React from 'react';

/**
 * Label-above field wrapper for stack panels.
 * Renders <label> + child input/select using .input-field / .select-field classes.
 */
const PanelField = ({ label, htmlFor, children, className = '' }) => (
  <div className={className}>
    {label && (
      <label
        htmlFor={htmlFor}
        className="font-mono text-[10px] uppercase tracking-[0.15em] text-zinc-500 mb-1 block"
      >
        {label}
      </label>
    )}
    {children}
  </div>
);

export default PanelField;
